export const EDIT_WALLET_START = 'EDIT_WALLET_START';
export const EDIT_WALLET_SUCCESS = 'EDIT_WALLET_SUCCESS';
export const EDIT_WALLET_ERROR = 'EDIT_WALLET_ERROR';
export const EDIT_WALLET_END = 'EDIT_WALLET_END';
export const EDIT_WALLET_CLEAR = 'EDIT_WALLET_CLEAR';
